import { render, staticRenderFns } from "./BusinessUnitDetail.vue?vue&type=template&id=5a958bce&scoped=true&"
import script from "./BusinessUnitDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a958bce",
  null
  
)

export default component.exports